import _head from 'lodash/head';

// constants
import { EMPTY_OBJECT } from 'tbase/app.constants';
import {
  PROJECT,
  COMMENTS,
  JIRA,
  TEST_CASE_NAME,
  PRIORITY,
  ACTIVE,
  AUTOMATED,
  COMPONENT,
  DESCRIPTION,
  TYPE,
  BRANCH,
  PRECONDITIONS,
  STEPS,
  EXIT_CRITERIA,
  RELEASE,
  REGRESSION,
  TCCATEGORY,
  UPSTREAMCONSUMPTION,
  DOWNSTREAMCONSUMPTION,
  HORIZONTALIMPLEMENTATION,
  MISC,
  AUTHOR,
} from '../organisms/TestCaseForm/helpers/testCasesForm.fields';

import { JIRAID } from '../organisms/editTestCase/constants/addTestCaseToJira.fields';

const makeTestCaseRequestDTO = (formValues, testCaseId) => {
  const requestDto = {
    id: testCaseId,
    name: formValues[TEST_CASE_NAME.id],
    [AUTHOR.id]: formValues[AUTHOR.id],
    [COMPONENT.id]: formValues[COMPONENT.id],
    [PRIORITY.id]: _head(formValues[PRIORITY.id]),
    [JIRA.id]: formValues[JIRA.id],
    [ACTIVE.id]: _head(formValues[ACTIVE.id]),
    [AUTOMATED.id]: _head(formValues[AUTOMATED.id]),
    [DESCRIPTION.id]: formValues[DESCRIPTION.id],
    [STEPS.id]: formValues[STEPS.id],
    [EXIT_CRITERIA.id]: formValues[EXIT_CRITERIA.id],
    [PRECONDITIONS.id]: formValues[PRECONDITIONS.id],
    [RELEASE.id]: formValues[RELEASE.id],
    [BRANCH.id]: formValues[BRANCH.id],
    [REGRESSION.id]: _head(formValues[REGRESSION.id]),
    [TYPE.id]: formValues[TYPE.id].join(","),
    [MISC.id]: formValues[MISC.id],
    [TCCATEGORY.id]: formValues[TCCATEGORY.id],
    [UPSTREAMCONSUMPTION.id]: formValues[UPSTREAMCONSUMPTION.id],
    [DOWNSTREAMCONSUMPTION.id]: formValues[DOWNSTREAMCONSUMPTION.id],
    [HORIZONTALIMPLEMENTATION.id]: formValues[HORIZONTALIMPLEMENTATION.id],
  };
  return requestDto;
};

export const makeAddTestCaseToJiraDto = (formValues) =>{
  const requestDto ={
    jiraId : formValues[JIRA.id],
    // id: testCaseId,
  }
  return requestDto;
}


export default makeTestCaseRequestDTO;
